/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Base_NameInputs */

const en_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const id_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bicara`)
};

const ms_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const ca_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa`)
};

const cs_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const da_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoopkald`)
};

const de_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const et_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const es_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videollamadas`)
};

const fr_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appels`)
};

const hr_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const it_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoconferenze`)
};

const lv_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarunas`)
};

const lt_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalbėkite`)
};

const hu_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videóhívás`)
};

const nl_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const nb_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const pl_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const pt_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const ro_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const sk_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const sl_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pogovor`)
};

const fi_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const sv_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtal`)
};

const vi_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chuyện`)
};

const tr_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const el_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνομιλία`)
};

const bg_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const ru_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разговоры Brave`)
};

const sr_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const uk_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const ka_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const hi_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const th_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const ko_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토크`)
};

const zh_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

const zh_tw_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視訊通話`)
};

const ja_talk_base_name = /** @type {(inputs: Talk_Base_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk`)
};

/**
* | output |
* | --- |
* | "Talk" |
*
* @param {Talk_Base_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_base_name = /** @type {((inputs?: Talk_Base_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Base_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_base_name(inputs)
	if (locale === "ms") return ms_talk_base_name(inputs)
	if (locale === "ca") return ca_talk_base_name(inputs)
	if (locale === "cs") return cs_talk_base_name(inputs)
	if (locale === "da") return da_talk_base_name(inputs)
	if (locale === "de") return de_talk_base_name(inputs)
	if (locale === "et") return et_talk_base_name(inputs)
	if (locale === "es") return es_talk_base_name(inputs)
	if (locale === "fr") return fr_talk_base_name(inputs)
	if (locale === "hr") return hr_talk_base_name(inputs)
	if (locale === "it") return it_talk_base_name(inputs)
	if (locale === "lv") return lv_talk_base_name(inputs)
	if (locale === "lt") return lt_talk_base_name(inputs)
	if (locale === "hu") return hu_talk_base_name(inputs)
	if (locale === "nl") return nl_talk_base_name(inputs)
	if (locale === "nb") return nb_talk_base_name(inputs)
	if (locale === "pl") return pl_talk_base_name(inputs)
	if (locale === "pt") return pt_talk_base_name(inputs)
	if (locale === "ro") return ro_talk_base_name(inputs)
	if (locale === "sk") return sk_talk_base_name(inputs)
	if (locale === "sl") return sl_talk_base_name(inputs)
	if (locale === "fi") return fi_talk_base_name(inputs)
	if (locale === "sv") return sv_talk_base_name(inputs)
	if (locale === "vi") return vi_talk_base_name(inputs)
	if (locale === "tr") return tr_talk_base_name(inputs)
	if (locale === "el") return el_talk_base_name(inputs)
	if (locale === "bg") return bg_talk_base_name(inputs)
	if (locale === "ru") return ru_talk_base_name(inputs)
	if (locale === "sr") return sr_talk_base_name(inputs)
	if (locale === "uk") return uk_talk_base_name(inputs)
	if (locale === "ka") return ka_talk_base_name(inputs)
	if (locale === "hi") return hi_talk_base_name(inputs)
	if (locale === "th") return th_talk_base_name(inputs)
	if (locale === "ko") return ko_talk_base_name(inputs)
	if (locale === "zh") return zh_talk_base_name(inputs)
	if (locale === "zh-tw") return zh_tw_talk_base_name(inputs)
	if (locale === "ja") return ja_talk_base_name(inputs)
	return en_talk_base_name(inputs)
});